export const iconFontAwesomeTravelHotelCar = (
	<i className="fa-solid fa-car"></i>
);
